export default [
    {
        path: '/customer',
        name: 'customer',
        component: () => import('@/pages/demo/Customer.vue'),
        meta: {
            auth: true,
        },
    },
]